/* eslint-disable import/no-anonymous-default-export */
import siteConfig, { formatMoney } from "../siteConfig";

export default {
  path: "/shipping",
  shortTitle: "Shipping",
  title: "Shipping and delivery",
  category: "Orders and delivery",
  summary: "Where orders leave from, when they dispatch, which tracked services are used and when delivery is expected.",
  updated: "5 November 2026",
  sections: [
    {
      heading: "Price and dispatch origin",
      body: [
        `Physical orders are prepared at the ${siteConfig.fulfilment.origin}. Checkout adds one store-subsidised tracked-delivery charge of ${formatMoney(siteConfig.shippingFee)} to the merchandise subtotal. The workshop listing is not a shipped product.`,
        `Prices and delivery charges are shown in ${siteConfig.currencyName} (${siteConfig.currency}). There is no free-shipping threshold or expedited upgrade in the current checkout.`,
      ],
    },
    {
      heading: "Processing time and carriers",
      body: [
        `Orders normally dispatch within ${siteConfig.fulfilment.dispatchTime}. Orders placed on weekends or Hong Kong public holidays start processing on the next business day. Customer care will email if a stock, address or product-safety check prevents that window.`,
        `Hong Kong parcels use ${siteConfig.fulfilment.carriers.domestic}. Macao, Taiwan, Japan, Singapore and South Korea use ${siteConfig.fulfilment.carriers.regional}. Other checkout destinations use ${siteConfig.fulfilment.carriers.international}. The final tracked service is selected for the parcel's destination, size and material.`,
        siteConfig.fulfilment.trackingNotice,
      ],
    },
    {
      heading: "Estimated delivery time",
      body: [
        `Hong Kong: ${siteConfig.fulfilment.deliveryEstimates.domestic}; normally ${siteConfig.fulfilment.totalEstimates.domestic} from payment confirmation.`,
        `Macao, Taiwan, Japan, Singapore and South Korea: ${siteConfig.fulfilment.deliveryEstimates.regional}; normally ${siteConfig.fulfilment.totalEstimates.regional} from payment confirmation.`,
        `Australia, Canada, France, Germany, New Zealand, the United Kingdom and the United States: ${siteConfig.fulfilment.deliveryEstimates.international}; normally ${siteConfig.fulfilment.totalEstimates.international} from payment confirmation.`,
        "These are estimates rather than guaranteed appointment dates. Customs, severe weather, remote-area hand-off and incomplete recipient information can extend delivery.",
      ],
    },
    {
      heading: "Packing, restrictions and receipt",
      body: [
        "Ceramics and glass receive separated cushioning; prints use flat rigid protection; food remains in its sealed retail pack; metal finishes and textiles use clean, dry barriers. A fragile or food item may be refused for a destination where the selected carrier or border authority does not accept it. Customer care will notify the buyer and reverse any captured amount if no compliant route is available.",
        "Inspect the outer parcel and fragile items promptly, keep the packaging, and photograph any damage, opening, wetness or missing contents. Delivery estimates and carrier restrictions do not remove rights concerning non-delivery, unsafe goods, defects or a material mismatch with the description.",
      ],
    },
  ],
};
